import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import {
    DefaultDataService,
    HttpUrlGenerator,
    Logger,
    Update,
} from 'ngrx-data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ACLServiceWeb } from '../ACLServices-web.service';
import { LegalCounsel } from './legal-counsel.dto';

@Injectable({
    providedIn: 'root',
})
export class LegalCounselDataService extends DefaultDataService<
    LegalCounsel
> {
    constructor(
        http: HttpClient,
        httpUserGenerator: HttpUrlGenerator,
        @Optional() logger: Logger,
        private aclServices: ACLServiceWeb
    ) {
        super('LegalCounsel', http, httpUserGenerator);
    }

    getAll(): Observable<LegalCounsel[]> {
        return this.aclServices.allLegalCounsels();
    }

    getLegalCounselById(key): Observable<LegalCounsel> {
        return this.aclServices.getLegalCounselById(key);
    }

    update(input: Update<LegalCounsel>): Observable<LegalCounsel> {
        return this.aclServices.updateLegalCounsel(input.changes);
    }

    add(input: LegalCounsel): Observable<LegalCounsel> {
        return this.aclServices.addLegalCounsel(input);
    }

    delete(key) {
        return this.aclServices
            .deleteLegalCounsel(key)
            .pipe(map(v => v.id));
    }
}
